// Aquí está el slice de seguidores
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  seguidoresInfo: null,
  seguidoresFailure: false,
  seguidoresError: null,
  seguidoresIsLoading: false,
};

const seguidoresSlice = createSlice({
  name: "seguidores",
  initialState,
  reducers: {
    seguidoresSuccess: (state, action) => {
      state.seguidoresInfo = action.payload.seguidoresInfo;
      state.seguidoresFailure = false;
      state.seguidoresIsLoading = false;
    },
    seguidoresFailure: (state, action) => {
      state.seguidoresFailure = true;
      state.seguidoresIsLoading = false;
      state.seguidoresError = action.payload;
    },
    seguidoresReset: (state) => {
      state.seguidoresInfo = null;
      state.seguidoresFailure = false;
      state.seguidoresError = null;
      state.seguidoresIsLoading = false;
    },
    crearSeguidorSuccess: (state, action) => {
      // Optionally update local state after following
    },
    eliminarSeguidorSuccess: (state, action) => {
      // Optionally update local state after unfollowing
    },
  },
});


export const {
  seguidoresSuccess,
  seguidoresFailure,
  seguidoresReset,
  crearSeguidorSuccess,
  eliminarSeguidorSuccess,
} = seguidoresSlice.actions;
export default seguidoresSlice.reducer;
